import { useEffect, useState } from "react";
import { getLocale } from "umi";
// import { ENGAGEMENT_RETENTION_TABLE } from "../../models/_config/filterDvaKey";
import { getDailyByTimezonePerformanceTable } from "../../services/multiTimezone";
import {LANGUAGE_MAP} from "@/pages/dashboard/_config/constant";

import { SortBy } from 'tea-component/es/table/addons';
import {formatAccumulation, formatFilterValues} from "@/pages/dashboard/utils/utils";
import { useOverLimitTrigger } from "@/pages/dashboard/components/OverLimitTip";
import { PagingQuery } from "../../components/PerformanceMetricsTable";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useDailyByTimezoneTableModel = (props: any, formValue: any, dispatch: any, filterLoading: boolean, accumulated: string[], paging: {}, sort: SortBy[], segmentValue: string, timezoneType: string) => {
// const defaultValue = useRealtimeDefaultFilterVal(timeZone);
  const { gameCode } = props;
  // const formVal = formValue || defaultValue;
  const [componentData, setComponentData] = useState({
    aggregation: [],
    metrics_list: [],
    row_count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { overLimitBarTriggerKey, handleResponse } = useOverLimitTrigger();

  // 筛选器、分页、排序改变的时候
  useEffect(() => {
    if (!formValue || filterLoading) return;
    getRetentionDataFunc(formValue, accumulated, paging, sort, segmentValue);
  }, [filterLoading, JSON.stringify(formValue), JSON.stringify(accumulated)]);

  const getRetentionDataFunc = (formValue: any, accumulated: string[], paging: PagingQuery, sort: SortBy[], segmentValue: string) => {
    const { rangeTime, timeType, diff, ...filters } = formValue;
    const accumulation = formatAccumulation(accumulated);
    const desc = sort?.[0]?.order === 'desc' || (!sort[0]);
    const sorted_by = sort?.[0]?.by?.replace(segmentValue, '') || 'date';
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: rangeTime?.[0],
      end_time: rangeTime?.[1],
      accumulation,
      period: 'daily',
      desc,
      sorted_by,
      page: paging?.pageIndex,
      page_size: paging?.pageSize,
      timezone_type: timezoneType,
    };
    setLoading(true);
    getDailyByTimezonePerformanceTable(params, LANGUAGE_MAP[getLocale()]).then((result: any) => {
      setLoading(false);
      setError(false);
      setComponentData(result);
      handleResponse(result?.front_logical_flag);
      dispatch({
        type: "engagementServiceData/getCountryComprisionTableFunc",
        payload: {
          result
        }
      });
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };


  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
    getData: getRetentionDataFunc,
    overLimitBarTriggerKey,
  };
};

export default useDailyByTimezoneTableModel;
